import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { CookiesEditModalComponent } from '../../shared/components/cookies-edit-modal/cookies-edit-modal.component';
import { CookiesNameType } from '../../shared/entities/enums/cookies-name-type';
import { TextUtils } from '../../shared/utils/text.utils';
import {MatDialog, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'gryf-cookies',
  templateUrl: './cookies.component.html',
})
export class CookiesComponent implements OnInit {

  constructor(
    private cookieService: CookieService,
    private matDialog: MatDialog,
  ) {
  }

  ngOnInit(): void {
  }

  openCookiesEditModal(): void {
    const dialogRef: MatDialogRef<CookiesEditModalComponent> = this.matDialog.open(CookiesEditModalComponent, {
      panelClass: 'cookies-edit-modal',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        window.location.reload();
      }
    });
  }

  enableAll(): void {
    this.cookieService.set(CookiesNameType.ANALYTICAL_COOKIES, TextUtils.randomString(30));
    this.cookieService.set(CookiesNameType.PERSONALIZED_ADS, TextUtils.randomString(30));
    window.location.reload();
  }
}
